define.alias("ember-composable-helpers/helpers/toggle-action", "settings/helpers/toggle-action");